import { DataItemType, FormControlType } from "../../../schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "../../common/components/system-control/pc/index.vue";
import mobile from "../../common/components/system-control/mobile/index.vue";
const info = {
    title: "创建时间",
    title_i18n: "{\"zh\": \"创建时间\", \"en\": \"CreatedTime\"}",
    type: "createdTime",
    icon: "h-icon-all-clock-circle-o",
    dataItemType: DataItemType.Date,
    formControllerType: FormControlType.CreatedTime,
    group: "系统控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
